import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import TopHeader from "../Common/TopHeader";
import { DisplayErrorMessages, DisplayToaster, PostApiMethod, restrictIntialSpace, GetApiMethod, PutApiMethod, ActivateDeactivate, Checkeligibility } from "../../core/services/apiService";
import { useForm } from "react-hook-form";
import AppModal from "../AppModal/AppModal";

const UserForm = () => {

    const [resultData, setResultData] = React.useState([]);
    React.useEffect(() => {
        (async () => {
            const result = await GetApiMethod('admin/vendor', { params: { filter_type: 'dropdown' } });
            setResultData(result.data.data);
        })();
    }, []);

    const { register, handleSubmit, formState: { errors }, setError } = useForm<any>();
    const [showPopUp, setShowPopUp] = React.useState<boolean>(false);

    const location = useLocation();

    const [loader, setLoader] = useState(false);

    const navigate = useNavigate();

    const pageDisable = () => {
        setLoader(true);
        document.body.classList.add('page-disable');
    };

    const pageEnable = () => {
        setLoader(false);
        document.body.classList.remove('page-disable');
    };

    Checkeligibility("/customer-admin/edit", location, "/customer-admin");

    const handleRegister = (data: any) => {
        const postData = {
            name: data.name?.trim(),
            email: data.email?.trim(),
            role: 'vendor_admin',
            vendor: data.vendor
        }

        pageDisable();
        location.pathname === '/customer-admin/create' ?
            PostApiMethod('admin/user', postData).then((res) => {
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate('/customer-admin');
                    DisplayToaster("bg-success", "Customer Admin " + data.name + " created successfully");
                }
            }).catch((err) => {
                pageEnable();
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            })
            :
            PutApiMethod('admin/user/' + location.state?.id, postData).then((res) => {
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate('/customer-admin');
                    DisplayToaster("bg-success", "Customer Admin " + data.name + " updated successfully");
                }
            }).catch((err) => {
                pageEnable();
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            })

    }

    return (
        <>
            <Container fluid className="mt-3" >
                <TopHeader
                    heading={(location.pathname === '/customer-admin/create') ? "Create Customer Admin" : (location.pathname === '/customer-admin/edit') ? "Edit Customer Admin - " + location.state?.names : " Customer Admin"}
                    to={"/customer-admin"}
                    className="fa-list"
                    action="List"
                    id="list-customer-admin"
                />

                {
                    showPopUp &&
                    (
                        <AppModal
                            title={`Confirm To ${location.state.is_active ? "Deactivate" : "Activate"}!`}
                            bodyText={
                                `Are you sure to ${location.state.is_active ? "deactivate" : "activate"} this Customer Admin ?`
                            }
                            primaryButtonLabel={"Yes"}
                            secondaryButtonLabel={"No"}
                            primaryButtonEventEmitter={() => { ActivateDeactivate("Customer Admin", location.state?.names, "admin/user", location.state.id, location.state.is_active, () => { navigate('/customer-admin') }); setShowPopUp(false) }
                            }
                            secondaryButtonEventEmitter={() => setShowPopUp(false)}
                        />
                    )
                }

                <Form onSubmit={handleSubmit(handleRegister)}  >
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Name <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" className="form-control" defaultValue={location.state?.names}
                                {...register('name', {
                                    required: true, minLength: 4, maxLength: 40, pattern: {
                                        value: /^[a-zA-Z ]*$/,
                                        message: 'Name field should contain only alphabets',
                                    },
                                })}
                            />
                            {errors.name && errors.name.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name && (errors.name.type === "minLength" || errors.name.type === "maxLength") && <small className='text-danger' >Name field should be between 4 to 40 characters</small>}
                            {errors.name && errors.name.type === "pattern" && <small className='text-danger' >Name field should contain only alphabets</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Email <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text"
                                defaultValue={location.state?.emails}
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                className="form-control" autoComplete="off"
                                {...register('email',
                                    {
                                        required: true,
                                        pattern: {
                                            value: /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/,
                                            message: 'Please enter a valid email',
                                        },
                                        setValueAs: (v) => v.trim()
                                    }
                                )}
                            />
                            {errors.email && errors.email.type === "required" && <small className='text-danger' >Email is required</small>}
                            {errors.email && errors.email.type === "pattern" && <small className='text-danger' >Please enter a valid email</small>}
                        </div>
                    </div>

                    {
                        location.pathname === '/customer-admin/create' &&
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Role </label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text" name="role" value="Customer Admin" className="form-control" disabled />
                            </div>
                        </div>
                    }

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Customer <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <select className="form-select" {...register('vendor', { required: true })} >
                                {location.pathname === '/customer-admin/create' ? <option value="">Select</option>
                                    : <option value={location.state?.customerId} hidden>
                                        {location.state?.vendors.name}
                                    </option>}
                                {resultData.map((items: any, i: number) => {
                                    return <option key={items._id} value={items._id}>{items.name}</option>
                                })}
                            </select>
                            {errors.vendor && errors.vendor.type === "required" && <small className='text-danger' >Customer is required</small>}
                        </div >
                    </div >

                    {
                        location.pathname === '/customer-admin/edit' &&
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Status </label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text" className="form-control" value={location.state?.is_active ? "Active" : "Inactive"} disabled />
                            </div>
                        </div>
                    }
                    < div className='text-center' >
                        <button type="submit" className='btn btn-primary app-button-color m-2'>{loader && (<span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>)} {location.pathname === '/customer-admin/create' ? "Submit" : "Update"}</button>
                        {location.pathname === '/customer-admin/edit' && <button type="button" className={location.state?.is_active ? "btn btn-danger" : "btn btn-success"} onClick={(e) => { setShowPopUp(true) }}>{location.state?.is_active ? "Deactivate" : "Activate"}</button>}
                        <button type="reset" className='btn btn-secondary m-2' onClick={(e) => { navigate('/customer-admin'); }}>Cancel</button>
                    </div >
                </Form >
            </Container >

        </>

    )
}

export default UserForm;